import { render, staticRenderFns } from "./FloatingLogo.vue?vue&type=template&id=a6f0f1e0&scoped=true&"
import script from "./FloatingLogo.vue?vue&type=script&lang=js&"
export * from "./FloatingLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6f0f1e0",
  null
  
)

export default component.exports